import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useState, useEffect } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import Home from "./pages/home";
import About from "./pages/about";
import Privacy from "./pages/privacy";
import Login from "./pages/login";
import Attendance from "./pages/attendance";
import KhidmatDetail from "./pages/khidmat-detail";
import Navbar from "./components/navbar";
import { auth } from "./firebaseAuth";
import { CoordinatorProvider } from "./context/CoordinatorContext";
import Dashboard from "./pages/dashboard";
import VideoIntro from "./components/video-intro";

function App() {
  const [user, setUser] = useState(null);
  const [showIntro, setShowIntro] = useState(true);
  const [hasSeenIntro, setHasSeenIntro] = useState(false);

  // Check if user has seen intro in this session
  useEffect(() => {
    const seenIntro = sessionStorage.getItem('hasSeenIntro');
    if (seenIntro) {
      setShowIntro(false);
      setHasSeenIntro(true);
    }
  }, []);

  // Listen for auth state changes
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  // Handle intro completion
  const handleIntroComplete = () => {
    setShowIntro(false);
    setHasSeenIntro(true);
    sessionStorage.setItem('hasSeenIntro', 'true');
  };

  // Logout Function
  const handleLogout = async () => {
    await signOut(auth);
  };

  // Protected Route for Attendance
  const CoordinatorRoute = ({ children }) => {
    return user ? children : <Navigate to="/login" />;
  };

  // Show intro video on first load
  if (showIntro) {
    return <VideoIntro onComplete={handleIntroComplete} />;
  }

  return (
    <CoordinatorProvider>
      <Router>
        <div className="min-h-screen bg-white">
          {/* Navigation Header */}
          <Navbar user={user} handleLogout={handleLogout} />
          {/* Main Content */}
          <div className="relative">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/login" element={<Login />} />
              <Route path="/khidmat/:khidmatKey" element={<KhidmatDetail />} />
              <Route
                path="/attendance"
                element={
                  <CoordinatorRoute>
                    <Attendance />
                  </CoordinatorRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <CoordinatorRoute>
                    <Dashboard />
                  </CoordinatorRoute>
                }
              />
            </Routes>
          </div>
        </div>
      </Router>
    </CoordinatorProvider>
  );
}

export default App;